import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import useAuth from 'src/hooks/useAuth';
import { UserTreeResponse } from 'src/types/work_area';
import axiosInstance from 'src/utils/axios';

/** Raw company user hierarchy tree. Filtering is applied in useWorkArea / useWorkAreaCompanyUsersTree. */
const useCompanyUsersTreeQuery = (companyId: number | null) => {
  const { user } = useAuth();
  const clientId = user?.ClientId;

  return useQuery<UserTreeResponse>({
    queryKey: queryKeys.workArea.companyUsersTree(companyId, clientId ?? null),
    queryFn: async () => {
      if (!clientId || companyId == null) {
        throw new Error('Missing clientId or companyId for user tree.');
      }
      const res = await axiosInstance.get<UserTreeResponse>(
        api.getCompanyUsersTree(companyId)
      );
      return res.data;
    },
    enabled: Boolean(clientId && companyId != null),
  });
};

export default useCompanyUsersTreeQuery;
